(($) => {
  $(document).ready(() => {
    const paragraph = $('.paragraph--type--person-tabs');
    paragraph.on('click', 'button', (e) => {
      const target = $(e.target);
      const targetId = target.data('tab-id');
      if (targetId !== undefined) {
        const p = target.closest('.paragraph--type--person-tabs');
        p.find('.active').removeClass('active');
        p.find(`*[data-tab-id="${targetId}"]`).addClass('active');
      }
    });
  });
})(jQuery);
